import { styled } from 'styled-components';

export const Dot = styled.span<{ $color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
  display: inline-flex;
  flex-shrink: 0;
`;
